import routes from '@/modules/account/routes'
import store from '@/modules/account/store'

export default { routes, store }
